<template>
    <div class="content">
        <div class="w">
            <div id="breadcrumb">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                        <el-breadcrumb-item>个人中心</el-breadcrumb-item>
                        <el-breadcrumb-item>在线申请</el-breadcrumb-item>
                    </el-breadcrumb>
            </div>
            <el-divider></el-divider>

            <keep-alive>
                <router-view/>
            </keep-alive>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods:{

    },
    activated(){
        
    },
}
</script>

<style scoped>
.w{
    width: 1170px;
    margin: 0 auto;
    text-align: left;
    margin-bottom:60px;
}
#breadcrumb{
    display: flex;
    align-items: center;
    text-align: justify;
    height:60px;
    color:#fff;
    margin-top: 145px;
}
.el-divider{
    margin: 0 0 60px 0;
}
.bottomdivider{
    margin-top:75px
}
</style>